/**
 * Polling interval (ms) for React Query hooks that display workflow step
 * status. Step statuses can change on the backend (steps completed by other
 * users, next steps auto-activated), so these views poll to pick up changes
 * without a manual reload. Only polls while the tab is focused.
 */
export const STEP_POLL_INTERVAL_MS = 20_000;
